import { coerce, integer, string } from 'superstruct';

/**
 * Allow parsable strings to be accepted for an integer.
 * Requires coercion to be set.
 */
export const parsableInteger = () => coerce(integer(), string(), value => value === '' || value === 'null' ? null : Number.parseInt(value));